<template>
    <div id="J_loading" class="loading">
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
        <p class="txt">数据加载中</p>
    </div>
</template>

<script>
	export default {
	  	data() {
		    return {

		    }
	  	},
        mounted(){
            // console.log(this.tabTitle)
        },
        methods: {

        }
	}
</script>
<style>
    .loading {
        padding: 0.1rem 0;
        background-color: #f9f9f9;
        /*display: none*/
    }

    .loading .txt {
        font-size: 0.22rem;
        padding: 0.1rem 0;
        text-align: center;
        color: #b3b3b3;
    }

    .loading .spinner {
        margin: 0 auto;
        width: 1.5rem;
        text-align: center;
    }

    .loading .spinner>div {
        width: 0.14rem;
        height: 0.14rem;
        background-color: #52ace5;
        border-radius: 100%;
        display: inline-block;
        -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
        animation: bouncedelay 1.4s infinite ease-in-out;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }

    .loading .spinner .bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }

    .loading .spinner .bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }

    @-webkit-keyframes bouncedelay {
        0%,
        80%,
        100% {
            -webkit-transform: scale(0.0);
        }
        40% {
            -webkit-transform: scale(1.0);
        }
    }

    @keyframes bouncedelay {
        0%,
        80%,
        100% {
            transform: scale(0.0);
            -webkit-transform: scale(0.0);
        }
        40% {
            transform: scale(1.0);
            -webkit-transform: scale(1.0);
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/loading.vue